import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortAgentComponent } from './port-agent.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PortAgentComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ]
})
export class PortAgentModule { }
